/**
 * Build provenance for the running client bundle.
 *
 * The GitHub Actions workflow passes `VITE_BUILD_SHA` and `VITE_BUILD_AT` at
 * build time so the in-app footer + telemetry can identify which exact commit
 * a browser is running. Same-day version bumps (multiple v1.5.8 deploys in
 * one calendar day) would otherwise be indistinguishable.
 *
 * In dev (`npm run dev`) neither var is set; we fall back to `'local'` so
 * downstream code doesn't need to special-case undefined.
 */

const rawSha = (import.meta.env.VITE_BUILD_SHA as string | undefined) ?? '';
const rawBuiltAt = (import.meta.env.VITE_BUILD_AT as string | undefined) ?? '';

export const BUILD_SHA: string = rawSha || 'local';
export const BUILD_SHORT_SHA: string = rawSha ? rawSha.slice(0, 7) : 'local';
export const BUILD_AT: string = rawBuiltAt || '';
